import Vue from 'vue';

import { Popup } from 'vue-ydui/dist/lib.rem/popup';
import { DateTime } from 'vue-ydui/dist/lib.rem/datetime';
import { ActionSheet } from 'vue-ydui/dist/lib.px/actionsheet';
import { CountDown } from 'vue-ydui/dist/lib.rem/countdown';
import { TimeLine, TimeLineItem } from 'vue-ydui/dist/lib.rem/timeline';

const components = {
    ActionSheet,
    Popup,
    CountDown,
    DateTime,
    TimeLine,
    TimeLineItem
};
Object.keys(components).forEach(key => {
    // Vue.use(components[key]);
    // console.log('key', components[key].name);
    Vue.component(components[key].name, components[key]);
});
